<template>
  <v-navigation-drawer
    v-if="$store.state.isUserLoggedIn"
    width="300"
    permanent
    app
    class="primary_header white--text"
  >
    <v-container fluid fill-height class="side-bar">
      <v-layout mb-3 align-start column fill-height>
        <v-flex text-xs-center class="link logo-container">
          <img v-if="$domain == $hwUrl" draggable="false" :src="require('@/assets/logo_pic_herdwatch.svg')" style="width:25%" alt="logo" class="logo" contain>
          <img
            draggable="false"
            :src="($domain == $hwUrl) ? require('@/assets/login_logo_herdwatch.svg') : require('@/assets/logo_pic.png')"
            alt="logo"
            class="logo"
            contain
          />
        </v-flex>
        <!-- <v-flex class="headline font-weight-bold">MOONSYST</v-flex> -->
        <v-flex class="user-name">
          {{ $store.state.user.username }}
          <br />
          Tz: {{ $store.state.user.timezone }} {{ $moment().tz($store.state.user.timezone).format("Z") }}
        </v-flex>
        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            :ripple="{ class: 'blue--text text--darken-2' }"
            :class="{
              'active-link': $route.path.includes('dashboard')
            } /* needed both class and active class because of nested routes not triggering proper active status */"
            active-class="active-link"
            :to="{ name: 'dashboard' }"
            class="button-link"
          >
            <img
              :src="
                $route.path.includes('dashboard')
                  ? require('@/assets/icons/msyst-icon_dashboard-orange.svg')
                  : require('@/assets/icons/msyst-icon_dashboard-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("dashboard") }}
          </v-btn>
        </v-flex>
        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{ name: 'companies' }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'companies'
                  ? require('@/assets/icons/msyst-icon_companies-orange.svg')
                  : require('@/assets/icons/msyst-icon_companies-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("company", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{ name: 'roles' }"
            class="button-link"
          >
            {{ $tc("role", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{ name: 'sites' }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'sites'
                  ? require('@/assets/icons/msyst-icon_sites-orange.svg')
                  : require('@/assets/icons/msyst-icon_sites-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("site", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'buildings'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'buildings'
                  ? require('@/assets/icons/msyst-icon_barns-orange.svg')
                  : require('@/assets/icons/msyst-icon_barns-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("barn", 2) }}
          </v-btn>
        </v-flex>

        <v-flex class="link divider"></v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'cows'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'cows'
                  ? require('@/assets/icons/msyst-icon_cows-orange.svg')
                  : require('@/assets/icons/msyst-icon_cows-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("cow", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'thi-sensors'
            }"
            class="button-link"
          >
            <img
              :src="
                ($route.name == 'thi-sensors' || $route.name == 'thi-sensor-details')
                  ? require('@/assets/icons/msyst-icon_boluses-orange.svg')
                  : require('@/assets/icons/msyst-icon_boluses-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("thiSensor", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'groups'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'groups'
                  ? require('@/assets/icons/msyst-icon_groups-orange.svg')
                  : require('@/assets/icons/msyst-icon_groups-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("group", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'boluses'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'boluses'
                  ? require('@/assets/icons/msyst-icon_boluses-orange.svg')
                  : require('@/assets/icons/msyst-icon_boluses-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("bolus", 2) }}
          </v-btn>
        </v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'data'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'data'
                  ? require('@/assets/icons/msyst-icon_data-orange.svg')
                  : require('@/assets/icons/msyst-icon_data-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("data", 2) }}
          </v-btn>
        </v-flex>
        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin, RoleTypes.CompanyUserShiftLeader, RoleTypes.CompanyUserVeterinarian].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'report'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'report'
                  ? require('@/assets/icons/msyst-icon_data-orange.svg')
                  : require('@/assets/icons/msyst-icon_data-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("report", 2) }}
          </v-btn>
        </v-flex>

        <v-flex class="link divider"></v-flex>

        <v-flex
          v-if="
            $store.state.user !== null &&
              ([RoleTypes.SuperAdmin, RoleTypes.CompanyAdmin].includes(
                $store.state.user.role_type
              ))
          "
          class="link"
        >
          <v-btn
            block
            flat
            dark
            active-class="active-link"
            :to="{
              name: 'users'
            }"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'users'
                  ? require('@/assets/icons/msyst-icon_users-orange.svg')
                  : require('@/assets/icons/msyst-icon_users-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("user", 2) }}
          </v-btn>
        </v-flex>

        <v-divider></v-divider>
        <v-spacer></v-spacer>

        <v-flex v-if="$store.state.isUserLoggedIn" class="link">
          <v-btn
            block
            flat
            dark
            :to="{
              name: 'privacy-policy'
            }"
            active-class="active-link"
            tag="a"
            class="button-link"
          > 
            <img
              :src="
                $route.name == 'privacy-policy'
                  ? require('@/assets/icons/msyst-icon_info-orange.svg')
                  : require('@/assets/icons/msyst-icon_info-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("privacyPolicy", 2) }}
          </v-btn>
        </v-flex>

        <v-flex v-if="$store.state.isUserLoggedIn" class="link">
          <v-btn
            block
            flat
            dark
            :to="{
              name: 'settings'
            }"
            active-class="active-link"
            tag="a"
            class="button-link"
          >
            <img
              :src="
                $route.name == 'settings'
                  ? require('@/assets/icons/msyst-icon_settings-orange.svg')
                  : require('@/assets/icons/msyst-icon_settings-white.svg')
              "
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $tc("settings", 2) }}
          </v-btn>
        </v-flex>

        <v-flex v-if="$store.state.isUserLoggedIn" class="link">
          <v-btn
            block
            flat
            dark
            @click="logout"
            tag="a"
            class="button-link button-logout"
          >
            <img
              :src="require('@/assets/logout_icon.png')"
              alt="logo"
              class="route-icon"
              contain
            />
            {{ $t("account.logOut") }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- </v-container> -->
  </v-navigation-drawer>
</template>

<script>
import {RoleTypes} from "@/constants/role_types";
export default {
  data() {
    return {
      RoleTypes: RoleTypes,
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("clearAll");
      this.$router.push({
        name: "login"
      });
    },
  }
};
</script>

<style scoped>
.link {
  width: 100%;
  flex-grow: 0;
}
.link.divider {
  width: 85%;
  border-bottom: 2px solid #fff;
  align-self: center;
  margin: 1em 0 1em 0;
}
.button-link {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 2em;
}
/deep/ .v-btn__content {
  justify-content: start !important;
}
/deep/ .active-link {
  color: var(--v-secondary-original) !important;
  background-color: var(--v-sidebar-active);
  padding-left: 3em;
}
.route-icon {
  width: 20px;
  height: 20px;
  margin: 10px;
}

.container.side-bar {
  padding: 0px;
  padding-bottom: 10px;
}

.logo-container {
  text-align: start;
  padding: 20px 20px 0 20px;
}

.Herdwatch .logo-container {
  padding: 20px 35px 0 35px;
}

.button-logout {
  padding-bottom: 10px;
}

.user-name {
  text-align: left;
  margin: 0 0 2em 2em;
  cursor: default;
  flex-grow: 0;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue